import React from "react";
import { Button } from "antd";
import classNames from "classnames";

const GlobalButton = ({
  type = "default",
  action = "default",
  variant = "page",
  children,
  onClick,
  disabled = false,
  loading = false,
  style = {},
  className,
  ...props
}) => {
  const baseClass = variant === "form" ? "form-btn" : "btn";

  const actionClass = {
    create: "btn-create",
    edit: "btn-edit",
    cancel: "btn-cancel",
    submit: "btn-submit",
    delete: "btn-delete",
    login: "btn-login",
    signup: "btn-signup",
    back: "btn-back",
    search: "btn-search",
    buy: "btn-buy",
  }[action];

  return (
    <Button
      type={type}
      className={classNames(baseClass, actionClass, className)} // ✅ merged
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      style={style}
      {...props}
    >
      {children}
    </Button>
  );
};

export default GlobalButton;
